export { IconComponent } from './lib/icon/icon.component';
export { IconService } from './lib/iconService/icon.service';
export { StyledIconComponent } from './lib/icon/styled-icon/styled-icon.component';